import jquery from "jquery";
window.$ = window.jQuery = jquery;

document.addEventListener('DOMContentLoaded', () => {
  var didScroll;
  var lastScrollTop = 0;
  var delta = 3;
  var navbarHeight = $('#shopify-section-header').outerHeight();

  $(window).on('scroll', function(event){
    didScroll = true;
  });

  setInterval(function() {
    if (didScroll) {
        hasScrolled();
        didScroll = false;
    }
  }, 250);

  function hasScrolled() {
    var st = $(window).scrollTop();
    // Make scroll more than delta
    if(Math.abs(lastScrollTop - st) <= delta)
      return;

    // If scrolled down and past the navbar, add class .nav-up.
    if (st > lastScrollTop && st > navbarHeight){
      // Scroll Down
      $('#shopify-section-header').addClass('shopify-section-header--hidden');
    } else {
      // Scroll Up
      if(st + $(window).height() < $(document).height()) {
        $('#shopify-section-header').removeClass('shopify-section-header--hidden');
      }
    }
    
    lastScrollTop = st;
  }
});



// var oHeader = {};
// (function() {
//   const COMPONENT = 'shopify-section-header';
//   const SELECTOR = document.getElementById(`${COMPONENT}`);
//   let lastScrollPosition;

//   /**
//    * Init
//    */
//   this.init = function() {
//     if (SELECTOR.length !== 0) {
//       oHeader.listen(); // Start listening ...
//     } else {
//       console.log(`Selector not found: '${COMPONENT}'`);
//     }
//   };

//   /**
//    * Listen for User Input after Init
//    */
//   this.listen = function() {
//     oHeader.scroll(); // Listen for Window Scroll
//   };

//   /**
//    * Scroll
//    *
//    * requires debounce()
//    */
//   this.scroll = function() {
//     oHeader.setScrollPos();
//     console.log('offset:', window.pageYOffset)
//     console.log('last:', oHeader.lastScrollPosition())
//     window.addEventListener(
//       'scroll',
//       oHeader.debounce(function() {
//         if (window.pageYOffset > oHeader.lastScrollPosition()) {
//           console.log('hide')
//           oHeader.hide();
//         } else {
//           oHeader.show();
//           console.log('show')
//         }
//         oHeader.setScrollPos();
//       }, 20, true)
//     );
//   };

//   /**
//    * Hide
//    * 
//    * Add modifier 'hidden' to element
//    */
//   this.hide = function(el) {
//     SELECTOR.classList.add(`${COMPONENT}--hidden`);
//   };

//   /**
//    * Show
//    * 
//    * Remove modifier 'hidden' from element
//    */
//   this.show = function(el) {
//     if(SELECTOR.classList.contains(`${COMPONENT}--hidden`)) {
//       SELECTOR.classList.remove(`${COMPONENT}--hidden`);
//     }
//   };

//   /**
//    * Get Last Scroll Position
//    */
//   this.lastScrollPosition = function() {
//     return lastScrollPosition;
//   };

//   /**
//    * Set New Scroll Position
//    */
//   this.setScrollPos = function() {
//     lastScrollPosition = window.pageYOffset;
//   };

//   /**
//    * Debounce
//    *
//    * Returns a function, that, as long as it continues to be invoked, will not be triggered. The function will be called after it stops being called for N milliseconds. If `immediate` is passed, trigger the function on the leading edge, instead of the trailing.
//    * From https://davidwalsh.name/javascript-debounce-function
//    *
//    * @param {func} func Function Callback
//    * @param {int} wait Time in ms
//    * @param {bool} immediate
//    */
//   this.debounce = function(func, wait, immediate) {
//     var timeout;
//     return function() {
//       var context = this,
//         args = arguments;
//       var later = function() {
//         timeout = null;
//         if (!immediate) func.apply(context, args);
//       };
//       var callNow = immediate && !timeout;
//       clearTimeout(timeout);
//       timeout = setTimeout(later, wait);
//       if (callNow) func.apply(context, args);
//     };
//   };
// }.apply(oHeader));

// document.addEventListener('DOMContentLoaded', () => {
//   oHeader.init();
// });